import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import StickyMobileCTA from "./components/StickyMobileCTA";
import Home from "./pages/Home";
import VideoProduction from "./pages/VideoProduction";
import Photography from "./pages/Photography";
import Animation from "./pages/Animation";
import Drone from "./pages/Drone";
import WhiteLabel from "./pages/WhiteLabel";
import Prices from "./pages/Prices";
import Showreel from "./pages/Showreel";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import IndustryPage from "./pages/IndustryPage";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import LocationPage from "./pages/LocationPage";
import { INDUSTRIES } from "./data/industries";
import { LOCATIONS } from "./data/locations";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/video-production-in-liverpool" element={<VideoProduction />} />
          <Route path="/photography-liverpool" element={<Photography />} />
          <Route path="/animation-liverpool" element={<Animation />} />
          <Route path="/drone-filming-aerial-photography-liverpool" element={<Drone />} />
          <Route path="/white-label" element={<WhiteLabel />} />
          <Route path="/video-production-prices" element={<Prices />} />
          <Route path="/showreel" element={<Showreel />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/thank-you" element={<ThankYou />} />

          {/* Location landing pages — footer-linked, ranks locally */}
          {LOCATIONS.map((l) => (
            <Route key={l.slug} path={`/${l.slug}`} element={<LocationPage slug={l.slug} />} />
          ))}

          {/* Industry / vertical landing pages, same legacy URLs */}
          {INDUSTRIES.map((i) => (
            <Route key={i.slug} path={`/${i.slug}`} element={<IndustryPage slug={i.slug} />} />
          ))}

          {/* Blog */}
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <StickyMobileCTA />
      </BrowserRouter>
    </div>
  );
}

export default App;
